import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-h5"
};
const _hoisted_2 = {
    key: 1,
    class: "text-h5"
};
import { inject, onMounted, reactive, ref } from "vue";
import { LedgerServiceSymbol } from "@/InjectionSymbols";
import { Ledger } from "@/model/Ledger";
import { validationRules } from "@/ValidationRules";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LedgerSettingsView',
    setup(__props) {
        const ledgerService = inject(LedgerServiceSymbol);
        const ledgers = reactive([]);
        const dialog = ref(false);
        const ledger = reactive(new Ledger());
        onMounted(() => {
            loadLedgers();
        });
        function loadLedgers() {
            ledgerService?.loadAllLedgers().then(ledgersResponse => {
                ledgers.length = 0;
                ledgers.push(...ledgersResponse);
            });
        }
        function editLedger(editLedger) {
            ledger.assign(editLedger);
            dialog.value = true;
        }
        function deleteLedger(ledger) {
            ledgerService.deleteLedger(ledger).then(() => {
                loadLedgers();
            });
        }
        function closeDialog() {
            ledger.assign(new Ledger());
            dialog.value = false;
        }
        function saveLedger() {
            ledgerService.saveLedger(ledger).then(() => {
                loadLedgers();
                closeDialog();
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            const _component_v_data_table = _resolveComponent("v-data-table");
            return (_openBlock(), _createBlock(_component_v_card, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, {
                        fluid: true,
                        class: "d-flex flex-wrap ma-0 pa-0"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, { class: "text-h4 text-start v-col-12" }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                    _createTextVNode(" Bankkonten ")
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_container, { class: "ma-0" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_data_table, {
                                        items: ledgers,
                                        headers: [
                                            { title: 'Bezeichnung', key: 'ledgerName' },
                                            { title: 'Rechnungs-Präfix', key: 'invoicePrefix' },
                                            { title: 'Bank', key: 'bankName' },
                                            { title: 'IBAN', key: 'iban' },
                                            { title: 'BIC', key: 'bic' },
                                            { title: '', key: 'actions' },
                                        ]
                                    }, {
                                        [`header.actions`]: _withCtx(() => [
                                            _createVNode(_component_v_dialog, {
                                                modelValue: dialog.value,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((dialog).value = $event)),
                                                "max-width": "500px"
                                            }, {
                                                activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_container, { class: "d-flex v-col-12 pa-0 ma-0 justify-center" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_btn, _mergeProps(props, { "data-cy": "add-ledger-btn" }), {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_icon, { color: "white" }, {
                                                                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                                            _createTextVNode("mdi-plus")
                                                                        ])),
                                                                        _: 1
                                                                    })
                                                                ]),
                                                                _: 2
                                                            }, 1040)
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_card, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_card_title, null, {
                                                                default: _withCtx(() => [
                                                                    (!ledger.id)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Neues Konto"))
                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_2, "Konto editieren"))
                                                                ]),
                                                                _: 1
                                                            }),
                                                            _createVNode(_component_v_card_text, null, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_container, { class: "pa-0 d-flex flex-wrap" }, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_v_text_field, {
                                                                                class: "v-col-6 compact",
                                                                                label: "Bezeichnung",
                                                                                variant: "outlined",
                                                                                density: "compact",
                                                                                rules: [_unref(validationRules).required],
                                                                                modelValue: ledger.ledgerName,
                                                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((ledger.ledgerName) = $event)),
                                                                                "data-cy": "ledger-name-input"
                                                                            }, null, 8, ["rules", "modelValue"]),
                                                                            _createVNode(_component_v_text_field, {
                                                                                class: "v-col-6 compact",
                                                                                label: "Rechnungs-Präfix",
                                                                                variant: "outlined",
                                                                                density: "compact",
                                                                                rules: [_unref(validationRules).required],
                                                                                modelValue: ledger.invoicePrefix,
                                                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((ledger.invoicePrefix) = $event)),
                                                                                "data-cy": "ledger-prefix-input"
                                                                            }, null, 8, ["rules", "modelValue"]),
                                                                            _createVNode(_component_v_text_field, {
                                                                                class: "v-col-12 compact",
                                                                                label: "Bank",
                                                                                variant: "outlined",
                                                                                density: "compact",
                                                                                rules: [_unref(validationRules).required],
                                                                                modelValue: ledger.bankName,
                                                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((ledger.bankName) = $event)),
                                                                                "data-cy": "ledger-bank-input"
                                                                            }, null, 8, ["rules", "modelValue"]),
                                                                            _createVNode(_component_v_text_field, {
                                                                                class: "v-col-12 compact",
                                                                                label: "IBAN",
                                                                                variant: "outlined",
                                                                                density: "compact",
                                                                                rules: [_unref(validationRules).required],
                                                                                modelValue: ledger.iban,
                                                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((ledger.iban) = $event)),
                                                                                "data-cy": "ledger-iban-input"
                                                                            }, null, 8, ["rules", "modelValue"]),
                                                                            _createVNode(_component_v_text_field, {
                                                                                class: "v-col-12 compact",
                                                                                label: "BIC",
                                                                                variant: "outlined",
                                                                                density: "compact",
                                                                                rules: [_unref(validationRules).required],
                                                                                modelValue: ledger.bic,
                                                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((ledger.bic) = $event)),
                                                                                "data-cy": "ledger-bic-input"
                                                                            }, null, 8, ["rules", "modelValue"])
                                                                        ]),
                                                                        _: 1
                                                                    })
                                                                ]),
                                                                _: 1
                                                            }),
                                                            _createVNode(_component_v_card_actions, null, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_spacer),
                                                                    _createVNode(_component_v_btn, {
                                                                        variant: "text",
                                                                        onClick: closeDialog,
                                                                        "data-cy": "cancel-ledger-btn"
                                                                    }, {
                                                                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                                            _createTextVNode(" Cancel ")
                                                                        ])),
                                                                        _: 1
                                                                    }),
                                                                    _createVNode(_component_v_btn, {
                                                                        variant: "text",
                                                                        onClick: saveLedger,
                                                                        "data-cy": "save-ledger-btn"
                                                                    }, {
                                                                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                                            _createTextVNode(" Save ")
                                                                        ])),
                                                                        _: 1
                                                                    })
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }, 8, ["modelValue"])
                                        ]),
                                        [`item.actions`]: _withCtx(({ item }) => [
                                            _createVNode(_component_v_icon, {
                                                class: "me-2",
                                                color: "info",
                                                size: "small",
                                                onClick: ($event) => (editLedger(item)),
                                                "data-cy": "edit-ledger-btn"
                                            }, {
                                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                    _createTextVNode(" mdi-pencil ")
                                                ])),
                                                _: 2
                                            }, 1032, ["onClick"]),
                                            _createVNode(_component_v_icon, {
                                                size: "small",
                                                color: "error",
                                                onClick: ($event) => (deleteLedger(item)),
                                                "data-cy": "delete-ledger-btn"
                                            }, {
                                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                    _createTextVNode(" mdi-delete ")
                                                ])),
                                                _: 2
                                            }, 1032, ["onClick"])
                                        ]),
                                        bottom: _withCtx(({}) => _cache[12] || (_cache[12] = [])),
                                        _: 2
                                    }, 1032, ["items"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
